import { useField } from "formik";

import useDependentField, {
  usePropertyExtractor,
} from "../../hooks/use-dependent-field";

import styles from "./TextArea.module.css";
import { classnames } from "../../utils/index.jsx";

export default function TextArea({
  label,
  dependon,
  marginForm = "margin-form",
  className,
  ...props
}) {
  const [field, meta] = useField(props);

  const classes = classnames(
    styles.control,
    meta.error && meta.touched ? styles.error : "",
    className,
  );

  useDependentField(props.name, dependon, usePropertyExtractor(props.name));

  return (
    <div className={classes}>
      <label>
        {label}
        <textarea
          {...field}
          {...props}
          className={classnames(marginForm, styles.textInput)}
        />
      </label>
      {meta.touched && meta.error && <div>{meta.error}</div>}
    </div>
  );
}
